import {conLog} from '../app/AppContext';

export function connectWebSock(socket = {reg: {}}) {
	socket.ws = new WebSocket(import.meta.env.VITE_PROXY_HOST_WS ??
        `${window.location.protocol.replace('http', 'ws')}//${window.location.host}/socket`);

	socket.ws.onopen = () => conLog('socket established');
	socket.ws.onmessage = e => {
		conLog(`socket msg: "${e.data}" (${socket.reg[e.data]?.length ?? 0} listening)`);
		socket.reg[e.data]?.forEach(cb => cb());
	};
	socket.ws.onclose = e => {
		conLog('socket closed:', e.reason, e.wasClean && '...reconnecting in 1s');
		if (e.wasClean)
			setTimeout(() => connectWebSock(socket), 1000);
	};
	socket.ws.onerror = e => conLog('socket error:', e.message);

	socket.on = (msg, cb) => {
		const cbArr = socket.reg[msg] || (socket.reg[msg] = []);
		if (!cbArr.includes(cb))
			cbArr.push(cb);
	};
	socket.off = (msg, cb) => socket.reg[msg]?.removeFirst(cb);

	return socket;
}
